import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LOCALES, isSupportedLocale, persistLocale } from '../i18n/config';

/**
 * Công tắc VI ↔ EN — plan §5.1 yêu cầu tường minh.
 *
 * Lựa chọn được lưu lại (xem `persistLocale`) nên không phải chọn lại sau mỗi
 * lần tải trang. Phase 6 sẽ đồng bộ tiếp vào hồ sơ người dùng để lựa chọn theo
 * người qua mọi thiết bị.
 */
export function LanguageSwitch(): ReactNode {
  const { t, i18n } = useTranslation();

  const change = (value: string): void => {
    if (!isSupportedLocale(value)) return;
    void i18n.changeLanguage(value);
    persistLocale(value);
  };

  return (
    <label className="language-switch">
      <span className="visually-hidden">{t('language.label')}</span>
      <select
        value={i18n.resolvedLanguage ?? 'vi'}
        onChange={(event) => change(event.target.value)}
        aria-label={t('language.label')}
      >
        {SUPPORTED_LOCALES.map((locale) => (
          <option key={locale} value={locale}>
            {t(`language.${locale}`)}
          </option>
        ))}
      </select>
    </label>
  );
}
